/* Set vh */
let vh = window.innerHeight * 0.01;
document.documentElement.style.setProperty("--vh", `${vh}px`);

/* Sticky Header */
var e = 0;
var headerAway = 50,
  headerSticky = 200;
headerSection = document.querySelector(".site-header");

window.addEventListener("scroll", function () {
  var t = window.scrollY || window.pageYOffset,
    n = window.pageYOffset || document.documentElement.scrollTop;

  if (n > e && t > headerAway) {
    headerSection.classList.add("header-away");
  } else {
    headerSection.classList.remove("header-away");
  }

  e = n <= 0 ? 0 : n;

  if (t >= headerSticky) {
    headerSection.classList.add("header-sticky");
  } else {
    headerSection.classList.remove("header-sticky");
  }
});

document.addEventListener("mousemove", function (e) {
  if (e.clientY < 200) {
    headerSection.classList.remove("header-away");
  }
});

/* Back to top */
function initBackToTopProgress() {
  const progressPath = document.querySelector(".back-to-top rect");
  if (!progressPath) return;

  const pathLength = progressPath.getTotalLength();
  progressPath.style.transition = progressPath.style.WebkitTransition = "none";
  progressPath.style.strokeDasharray = `${pathLength} ${pathLength}`;
  progressPath.style.strokeDashoffset = pathLength;
  progressPath.getBoundingClientRect(); // Trigger a layout so styles are calculated
  progressPath.style.transition = progressPath.style.WebkitTransition =
    "stroke-dashoffset 10ms linear";

  // Function to update the progress indicator based on scroll position
  const updateProgress = () => {
    const scroll = window.scrollY || document.documentElement.scrollTop;
    const height = document.documentElement.scrollHeight - window.innerHeight;
    const progress = pathLength - (scroll * pathLength) / height;
    progressPath.style.strokeDashoffset = progress;
  };

  // Initial update of the progress indicator
  updateProgress();

  // Update progress on scroll
  window.addEventListener("scroll", updateProgress);
}

// Function to toggle the visibility of the back-to-top button
function toggleBackToTopButton() {
  const backToTopButton = document.querySelector(".back-to-top");
  if (!backToTopButton) return;

  const offset = 500;
  window.addEventListener("scroll", () => {
    if (window.scrollY > offset) {
      backToTopButton.classList.add("active");
    } else {
      backToTopButton.classList.remove("active");
    }
  });

  // Smooth scroll to top on button click
  backToTopButton.addEventListener("click", (event) => {
    event.preventDefault();
    window.scrollTo({ top: 0, behavior: "smooth" });
  });
}

// Initialize all back-to-top functionalities
function initBackToTop() {
  initBackToTopProgress();
  toggleBackToTopButton();
}

// Initialize back-to-top on document load
//document.addEventListener('DOMContentLoaded', initBackToTop);

/*  Footer accordion */
document
  .querySelectorAll("footer .footer-block__heading")
  .forEach(function (header) {
    header.addEventListener("click", function () {
      document
        .querySelectorAll("footer .footer-block__heading")
        .forEach(function (h4) {
          h4.classList.remove("current");
        });
      this.classList.toggle("current");
    });
  });

/* Animations */
const SCROLL_ANIMATION_TRIGGER_CLASSNAME = "scroll-trigger";
const SCROLL_ANIMATION_OFFSCREEN_CLASSNAME = "scroll-trigger--offscreen";
const SCROLL_ZOOM_IN_TRIGGER_CLASSNAME = "animate--zoom-in";
const SCROLL_ANIMATION_CANCEL_CLASSNAME = "scroll-trigger--cancel";

// Scroll in animation logic
function onIntersection(elements, observer) {
  elements.forEach((element, index) => {
    if (element.isIntersecting) {
      const elementTarget = element.target;
      if (
        elementTarget.classList.contains(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME)
      ) {
        elementTarget.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
        if (elementTarget.hasAttribute("data-cascade"))
          elementTarget.setAttribute("style", `--animation-order: ${index};`);
      }
      observer.unobserve(elementTarget);
    } else {
      element.target.classList.add(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
      element.target.classList.remove(SCROLL_ANIMATION_CANCEL_CLASSNAME);
    }
  });
}

function initializeScrollAnimationTrigger(
  rootEl = document,
  isDesignModeEvent = false
) {
  const animationTriggerElements = Array.from(
    rootEl.getElementsByClassName(SCROLL_ANIMATION_TRIGGER_CLASSNAME)
  );
  if (animationTriggerElements.length === 0) return;

  if (isDesignModeEvent) {
    animationTriggerElements.forEach((element) => {
      element.classList.add("scroll-trigger--design-mode");
    });
    return;
  }

  const observer = new IntersectionObserver(onIntersection, {
    rootMargin: "0px 0px -50px 0px",
  });
  animationTriggerElements.forEach((element) => observer.observe(element));
}

// Zoom in animation logic
function initializeScrollZoomAnimationTrigger() {
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

  const animationTriggerElements = Array.from(
    document.getElementsByClassName(SCROLL_ZOOM_IN_TRIGGER_CLASSNAME)
  );

  if (animationTriggerElements.length === 0) return;

  const scaleAmount = 0.2 / 100;

  animationTriggerElements.forEach((element) => {
    let elementIsVisible = false;
    const observer = new IntersectionObserver((elements) => {
      elements.forEach((entry) => {
        elementIsVisible = entry.isIntersecting;
      });
    });
    observer.observe(element);

    element.style.setProperty(
      "--zoom-in-ratio",
      1 + scaleAmount * percentageSeen(element)
    );

    window.addEventListener(
      "scroll",
      throttle(() => {
        if (!elementIsVisible) return;

        element.style.setProperty(
          "--zoom-in-ratio",
          1 + scaleAmount * percentageSeen(element)
        );
      }),
      { passive: true }
    );
  });
}

function percentageSeen(element) {
  const viewportHeight = window.innerHeight;
  const scrollY = window.scrollY;
  const elementPositionY = element.getBoundingClientRect().top + scrollY;
  const elementHeight = element.offsetHeight;

  if (elementPositionY > scrollY + viewportHeight) {
    // If we haven't reached the image yet
    return 0;
  } else if (elementPositionY + elementHeight < scrollY) {
    // If we've completely scrolled past the image
    return 100;
  }

  // When the image is in the viewport
  const distance = scrollY + viewportHeight - elementPositionY;
  let percentage = distance / ((viewportHeight + elementHeight) / 100);
  return Math.round(percentage);
}

window.addEventListener("DOMContentLoaded", () => {
  initializeScrollAnimationTrigger();
  initializeScrollZoomAnimationTrigger();
});

if (Shopify.designMode) {
  document.addEventListener("shopify:section:load", (event) =>
    initializeScrollAnimationTrigger(event.target, true)
  );
  document.addEventListener("shopify:section:reorder", () =>
    initializeScrollAnimationTrigger(document, true)
  );
}

// On click to open popup
// Toggle popup and class on click of tabs and read-more links

jQuery(document).ready(function (e) {
  // We execute the same script as before
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty("--vh", `${vh}px`);

  setTimeout(function () {
    jQuery("body").addClass("loaded");
  }, 100);

  jQuery(".scroll-down").click(function () {
    jQuery("html, body").animate(
      {
        scrollTop: jQuery("section").next().offset().top,
      },
      1000
    );
  });

  // Add smooth scrolling to all links
  jQuery(".internal, .internal-child a").on("click", function (event) {
    if (this.hash !== "") {
      var hash = this.hash;

      jQuery("html, body").animate(
        {
          scrollTop: jQuery(hash).offset().top - 100,
        },
        1000,
        function () {
          window.location.hash = hash;
        }
      );
      return false;
    }
  });

  gsap.registerPlugin(ScrollTrigger);

  // Function to initialize parallax effect
  function initializeParallax() {
    gsap.utils
      .toArray(".banner, .image-with-text__media, .media-parallax")
      .forEach((container) => {
        const img = container.querySelector("img, video");

        const tl = gsap.timeline({
          scrollTrigger: {
            trigger: container,
            scrub: true,
            pin: false,
            invalidateOnRefresh: true,
            onEnter: () => {
              gsap.to(img, { opacity: 1, scale: 1.1, duration: 0.3 });
            },
          },
        });

        tl.fromTo(
          img,
          { yPercent: -20, ease: "none" },
          { yPercent: 20, ease: "none" }
        );
      });
  }

  // Initialize parallax effect once at the start
  initializeParallax();

  // Observe changes in the DOM to reinitialize ScrollTrigger
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.addedNodes.length) {
        ScrollTrigger.refresh(); // Refresh ScrollTrigger on new content load
      }
    });
  });

  // Start observing the body for added content that changes layout
  observer.observe(document.body, { childList: true, subtree: true });

  // Refresh ScrollTrigger on window resize as a fallback
  window.addEventListener("resize", () => ScrollTrigger.refresh());

  if (jQuery(".more-info-popup").length) {
    // Toggle popup on click of tab or read-more link
    var tabsToggle = jQuery(
      ".more-info .tabs a, .product__short__description .read-more"
    );
    tabsToggle.on("click", function (event) {
      var hash = this.hash;
      var popup = jQuery(hash);
      if (popup.length) {
        popup.toggleClass("active");
      }
      jQuery("html").toggleClass("popup-open");
      event.preventDefault();
    });

    // Close popup on click of the close button
    var closeButtons = jQuery(
      ".more-info-popup .close, #table-of-contents #toc-list li a"
    );
    closeButtons.on("click", function () {
      jQuery(".more-info-popup").removeClass("active");
      jQuery("html").removeClass("popup-open");
    });

    // Close popup when clicking outside of the popup content
    jQuery(document).on("click", function (event) {
      var popupBox = jQuery(".more-info-popup .inner");
      var tabs = jQuery(
        ".more-info .tabs a, .product__short__description .read-more"
      );

      var isClickInsidePopup = popupBox.has(event.target).length > 0;
      var isClickInsideTabs =
        tabs.is(event.target) || tabs.has(event.target).length > 0;

      if (!isClickInsidePopup && !isClickInsideTabs) {
        jQuery(".more-info-popup").removeClass("active");
        jQuery("html").removeClass("popup-open");
      }
    });
  }

  // init Isotope
  if (jQuery(".blog-isotope").length) {
    var itemSelector = ".item";
    var $grid = $(".blog-isotope").isotope({
      itemSelector: itemSelector,
      layoutMode: "fitRows",
    });
    $(".blog-filter").on("click", "a", function () {
      var filterValue = $(this).attr("data-filter");
      filterValue = filterValue;
      $grid.isotope({ filter: filterValue });
    });
    $(".blog-filter").each(function (i, buttonGroup) {
      var $buttonGroup = $(buttonGroup);
      $buttonGroup.on("click", "a", function () {
        $buttonGroup.find(".is-checked").removeClass("is-checked");
        $(this).addClass("is-checked");
      });
    });

    function adjustWidths() {
      setTimeout(function () {
        var visibleItems = [];
        $(itemSelector)
          .parent()
          .children(".item")
          .each(function (i) {
            if ($(this).is(":visible")) {
              visibleItems.push($(this));
            }
          });

        visibleItems.forEach(function (item) {
          item[0].classList.remove("item-50");
          item[0].classList.remove("item-25");
        });

        visibleItems.forEach(function (item, index) {
          // Repeat every group of 6 items
          var groupIndex = index % 6;

          if (groupIndex < 2) {
            // First 2 items in the group get 'item-50'
            item[0].classList.add("item-50");
          } else {
            // Next 4 items in the group get 'item-25'
            item[0].classList.add("item-25");
          }
        });
        $grid.isotope("layout");
      }, 50);
    }

    adjustWidths();

    $grid.on("arrangeComplete", function () {
      adjustWidths();
    });
  }
  if (jQuery(".login-trigger").length) {
    var loginPopup = $("#login-popup");
    var loginBtn = $(".login-trigger");
    var closeBtn = $(".popup-close");

    // Open the login popup
    loginBtn.on("click", function () {
      loginPopup.show();
    });

    // Close the login popup
    closeBtn.on("click", function () {
      loginPopup.hide();
    });

    // Close the popup when clicking outside of it
    $(window).on("click", function (event) {
      if ($(event.target).is(loginPopup)) {
        loginPopup.hide();
      }
    });
  }

  if (jQuery("#newsletter-popup").length) {
    var newsletterPopup = $("#newsletter-popup");
    var newsletterBtn = $('[href="#newsletter"]');
    var closeBtn = $(".popup-close");

    // Open the newsletter popup
    newsletterBtn.on("click", function () {
      newsletterPopup.show();
    });

    // Close the newsletter popup
    closeBtn.on("click", function () {
      newsletterPopup.hide();
    });

    // Close the popup when clicking outside of it
    $(window).on("click", function (event) {
      if ($(event.target).is(newsletterPopup)) {
        newsletterPopup.hide();
      }
    });
  }

  if (jQuery(".lang").length) {
    var langBtn = jQuery(".lang-trigger");
    setTimeout(function () {
      jQuery("body .ts-dropdown-expand--multi>div").prepend(
        "<div class='heading'><span class='popup-close'>" +
          window.langStrings.langClose +
          "</span><h4>" +
          window.langStrings.langbased +
          "</h4><p>" +
          window.langStrings.langtext +
          "</p></div>"
      );
      jQuery(".popup-close").on("click", function () {
        jQuery("body .ts-dropdown-expand--multi").removeClass(
          "ts-dropdown-expand__active"
        );
      });
    }, 2000);

    langBtn.on("click", function () {
      jQuery("body .ts-dropdown-expand--multi").addClass(
        "ts-dropdown-expand__active"
      );
    });

    jQuery(window).on("click", function (event) {
      if (jQuery(event.target).is(jQuery("body .ts-dropdown-expand--multi"))) {
        jQuery("body .ts-dropdown-expand--multi").removeClass(
          "ts-dropdown-expand__active"
        );
      }
    });
  }

  if (jQuery(".account .sidebar").length) {
    var currentUrl = window.location.pathname;

    $(".account .sidebar a").each(function () {
      var linkUrl = $(this).attr("href");

      if (currentUrl.indexOf(linkUrl) !== -1) {
        $(this).addClass("active");
      }
    });
  }

  var ContactPopup = $("#ContactPopup");
  // Success function

  $("#ContactPopup").submit(function (e) {
    e.preventDefault();

    $.ajax({
      type: "POST",
      url: ContactPopup.attr("action"),
      cache: false,
      data: $(this).serialize(),
      error: function (t) {
        // ContactPopup.find("#ContactPopup-error").fadeIn();
      },
      success: function (data) {
        ContactPopup.find("#ContactPopup-success").fadeIn();
      },
    });
  });

  $(".product-form__input input[type='radio']").on("change", function () {
    setTimeout(function () {
      checkAppstle();
    }, 100);
  });

  // Share
  $(".social-sharing .subtitle").click(function (e) {
    $(this).parent().toggleClass("open");
  });

  $(".share-copy_link").click(function (e) {
    e.preventDefault();
    var copyText = $(this).attr("href");

    document.addEventListener(
      "copy",
      function (e) {
        e.clipboardData.setData("text/plain", copyText);
        e.preventDefault();
      },
      true
    );

    document.execCommand("copy");
    alert("Link copied.");
  });

  jQuery(".has-video").click(function (e) {
    video = jQuery(this).find("video").get(0);
    if (!jQuery(e.target).closest("a").length) {
      if (video.muted) {
        video.muted = false;
        jQuery(".cursor").removeClass("mute");
        jQuery(".cursor").addClass("unmute");
      } else {
        video.muted = true;
        jQuery(".cursor").removeClass("unmute");
        jQuery(".cursor").addClass("mute");
      }
    }
  });

  // collapsible
  if (jQuery(".collapsible-header").length) {
    jQuery(".collapsible-header").on("click", function () {
      jQuery(".collapsible-header")
        .not(this)
        .removeClass("active")
        .next()
        .slideUp();

      jQuery(this).toggleClass("active").next().slideToggle();
    });
  }

  //Follow cursor
  if (jQuery(".cursor").length) {
    if (jQuery(".has-video").length) {
      jQuery(".has-video").on({
        mouseenter: function () {
          jQuery(".cursor").addClass("is-audio");
        },
        mouseleave: function () {
          jQuery(".cursor").removeClass("is-audio");
        },
      });
    }

    jQuery(".scroll-down").on("mouseenter", function (e) {
      e.stopPropagation();
      jQuery(".cursor").removeClass("is-audio");
    });

    jQuery(".scroll-down").on("mouseleave", function (e) {
      e.stopPropagation();
      jQuery(".cursor").addClass("is-audio");
    });

    jQuery(document).mouseleave(function () {
      jQuery(".cursor").addClass("is-hidden");
    });
    jQuery(document).mouseenter(function () {
      jQuery(".cursor").removeClass("is-hidden");
    });

    var cursor = document.querySelector(".cursor");
    TweenLite.set(cursor, {
      xPercent: -50,
      yPercent: -50,
    });
    window.addEventListener("mousemove", movecursor);

    function movecursor(e) {
      TweenLite.to(cursor, 0.4, {
        x: e.clientX,
        y: e.clientY,
      });
    }
  }

  // Data based on variant
  if (jQuery(".product__info-container .more-info .item").length) {
    const currentVariantId = jQuery('input[name="id"]').val();
    jQuery(".variant-" + currentVariantId).css("display", "block");

    jQuery('input[name="id"]').on("change", function () {
      jQuery(".collapsible-body .item").hide();
      const selectedVariantId = ".variant-" + jQuery(this).val();
      jQuery(selectedVariantId).css("display", "block");
    });
  }

  jQuery(".article-page .banner").parent().addClass("container-fluid");
});

jQuery(document).ready(checkAppstle);

function checkAppstle() {
  if (jQuery(".product-page").length) {
    if ($(".appstle_select").is(":visible")) {
      createSubscriptionDropdown();
    } else {
      setTimeout(checkAppstle, 50);
    }
  }
}

function createSubscriptionDropdown() {
  $(".appstle_subscribe_option").append('<span id="updated-price"></span>');
  var selectElement = $(".appstle_select");
  var quantityInput = $("input[name='quantity']");

  var monthlyOptgroup = $('<optgroup label="Monthly"></optgroup>');
  var semiannualOptgroup = $('<optgroup label="Semi-Annual"></optgroup>');
  var yearlyOptgroup = $('<optgroup label="Yearly"></optgroup>');
  var priceElement = $("#updated-price");

  selectElement.find("option").each(function () {
    var optionText = $(this).text().split("/")[0].trim().toLowerCase();
    if (optionText.includes("12")) {
      yearlyOptgroup.append($(this));
    } else if (optionText.includes("6")) {
      semiannualOptgroup.append($(this));
    } else {
      monthlyOptgroup.append($(this));
    }
  });

  selectElement.empty();
  selectElement.append(monthlyOptgroup);
  selectElement.append(semiannualOptgroup);
  selectElement.append(yearlyOptgroup);

  selectElement.prepend("<option selected></option>").select2({
    templateResult: formatOption,
    templateSelection: formatOption,
    minimumResultsForSearch: -1,
    placeholder: "Select your subscription wishes",
  });

  var changeFlag = true;
  var quantity = 1;

  selectElement.on("change", function (e) {
    var selectedText = selectElement
      .find("option:selected")
      .text()
      .toLowerCase();

    if (selectedText.includes("12")) {
      quantity = 12;
    } else if (selectedText.includes("6")) {
      quantity = 6;
    } else {
      quantity = 1;
    }
    quantityInput.val(quantity);
    totalPrice();

    var elemid = jQuery(e.delegateTarget).attr("id");
    if (changeFlag) {
      selectHelperForcefully(elemid);
    } else {
      setTimeout(() => {
        changeFlag = true;
      }, 500);
    }
  });

  totalPrice();

  function totalPrice() {
    // Calculate and display the updated price
    setTimeout(() => {
      var basePrice = $(
        ".price__regular .appstle_subscription_final_price .trans-money"
      );
      if (jQuery(basePrice).length) {
        var finalPrice = parseFloat(
          basePrice
            .text()
            .replace(/[^0-9,.-]+/g, "")
            .replace(",", ".")
        );
        var currencySymbol = basePrice.text().match(/[^0-9.,\s]+/g);
        var updatedPrice = (finalPrice * quantity).toFixed(2).replace(".", ",");
        priceElement.text(currencySymbol + updatedPrice);
      }
    }, 500);
  }

  function selectHelperForcefully(elemid) {
    if (changeFlag) {
      changeFlag = false;
      const fevent = new Event("change", { bubbles: true });
      document.getElementById(elemid).dispatchEvent(fevent);
    }
  }

  function formatOption(option) {
    if (!option.id) {
      return option.text;
    }
    var parts = option.text.split("/");
    var mainText = parts[0].trim();
    var subText = parts[1] ? "<small>" + parts[1].trim() + "</small>" : "";
    var subText1 = parts[2]
      ? "<em>" + parts[2].trim() + "/" + parts[3].trim() + "</em>"
      : "";
    var formatted = $(
      "<span>" + mainText + " / " + subText + subText1 + "</span>"
    );
    return formatted;
  }
}

function openTab(evt, tabName) {
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("item");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].classList.remove("active");
  }
  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  document.getElementById(tabName).classList.add("active");
  evt.currentTarget.className += " active";
}
